module.exports = __webpack_public_path__ + "static/img/SO.2f2ed5a4.svg";